export class SensorCalibration {
    machineSerialNumber: string;
    machineInstallationName: string;
    dateTime: Date;
    sensorNum: number;
    averageCalibrationLevel: number;
    averageCommThr: number;
    stdCalibrationLevel: number;
    cleanThr: number;

    constructor() {
        this.machineSerialNumber = null;
        this.machineInstallationName = null;
        this.dateTime = null;
        this.sensorNum = null;
        this.averageCalibrationLevel = null;
        this.averageCommThr = null;
        this.stdCalibrationLevel = null;
        this.cleanThr = null;
    }

    public parse(obj: any) {
        if (obj.MachineSerialNumber) this.machineSerialNumber = obj.MachineSerialNumber;
        if (obj.MachineInstallationName) this.machineInstallationName = obj.MachineInstallationName;
        if (obj.DateTime) this.dateTime = new Date(obj.DateTime);
        if (obj.SensorNum) this.sensorNum = obj.SensorNum;
        if (obj.AverageCalibrationLevel !== null) this.averageCalibrationLevel = obj.AverageCalibrationLevel;
        if (obj.AverageCommThr) this.averageCommThr = obj.AverageCommThr;
        if (obj.STDCalibrationLevel) this.stdCalibrationLevel = obj.STDCalibrationLevel;
        if (obj.CleanThr) this.cleanThr = obj.CleanThr;
    }
}
